// modules
import React, { Fragment } from 'react';
import { observer } from 'mobx-react';
import { useStore } from 'modules/Stores';
import PlatformService from 'modules/Platform';
// components
import { View } from '@upstox/upstox-ui';
import Modal from 'app/components/MainLayout/components/Modal';
// constants
import { EXTERNAL_LINKS } from 'app/routing/registration';
import { ENV } from 'config';
// styles
import * as css from './styles';

const TBTVideoModal = () => {
  const {
    toggleModal,
    modalsConfig: { tbtVideoModal },
  } = useStore('AppStore');

  const onClose = () => {
    toggleModal('tbtVideoModal');
  };

  return tbtVideoModal ? (
    <Modal
      onClose={onClose}
      title="Introducing Tick-by-Tick Charting Data"
      styles={css.modalWrapper}
      cssProps={{ fullScreen: PlatformService.isMobile }}
    >
      <View
        as="div"
        css={css.videoIFrame}
        cssProps={{ fullScreen: PlatformService.isMobile }}
      >
        <iframe
          src={EXTERNAL_LINKS.TBT_VIDEO_LINK[ENV]}
          title="YouTube video player"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        />
      </View>
    </Modal>
  ) : (
    <Fragment />
  );
};

export default observer(TBTVideoModal);
